import React from "react";
import type { ReactNode } from "react";
import { C } from "../styles";

interface ResourceLinkProps {
  icon: ReactNode;
  label: string;
  mins?: string;
  onClick: () => void;
  isLast?: boolean;
}

export default function ResourceLink({
  icon,
  label,
  mins,
  onClick,
  isLast,
}: ResourceLinkProps) {
  return (
    <div
      onClick={onClick}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 11,
        padding: "10px 0",
        fontSize: 13.5,
        color: C.tealInk,
        fontWeight: 500,
        cursor: "pointer",
        borderBottom: isLast ? "none" : "1px solid " + C.lineSoft,
      }}
    >
      <span style={{ color: C.faint, display: "inline-flex" }}>{icon}</span>
      {label}
      {mins && (
        <span
          style={{
            marginLeft: "auto",
            fontSize: 12,
            color: C.faint,
            fontWeight: 500,
          }}
        >
          {mins}
        </span>
      )}
    </div>
  );
}